import apiClient from "../../../apis/tenant-management/tenant-management-client";
import { toast } from "react-toastify";
import { BaseApplicationService } from "../../../domain/base/base-application-service";
import { User } from "../../../domain/user/user";
import { Group } from "../../../domain/group/group";
import { rebuildQuery } from "../../../../utils/url-utils";
import {
  DefaultNumItemsPerPages,
  toTotalPage,
} from "../../../domain/pagination/paging";
import { reportUnexpectedError } from "../../../../error-reporter";

export type GroupUsersServiceProps = {
  isLoading: boolean;
  users: Array<User>;
  group: Group;
  paging: {
    current: number;
    total: number;
  };
  setPage: typeof GroupUsersService.prototype.setPage;
  movePage: typeof GroupUsersService.prototype.movePage;
  onMountUsers: typeof GroupUsersService.prototype.onMountUsers;
};

export class GroupUsersService extends BaseApplicationService<GroupUsersServiceProps> {
  private readonly userCountPerPage: number = DefaultNumItemsPerPages;

  state = {
    isLoading: false,
    users: [],
    group: {
      name: "",
      email: "",
      isDefault: true,
      isIgnoreAclSetting: false,
    },
    paging: {
      current: 1,
      total: 0,
    },
    setPage: this.setPage.bind(this),
    movePage: this.movePage.bind(this),
    onMountUsers: this.onMountUsers.bind(this),
  };

  setPage(p: number) {
    this.setState({
      paging: {
        ...this.state.paging,
        current: p,
      },
    });
  }

  movePage(p: number) {
    this.history.push(
      rebuildQuery({
        page: p.toString(),
      }),
    );
  }

  async onMountUsers(groupId: string) {
    await this.fetchGroup(groupId);
    await this.fetchUsers(groupId);
  }

  private async fetchGroup(groupId: string) {
    this.setIsLoading(true);
    try {
      const { data: group } = await apiClient.fetchGroupById(groupId);
      this.setState({
        group,
      });
    } catch (e) {
      reportUnexpectedError(e);
      toast.error("グループの取得に失敗しました。");
    } finally {
      this.setIsLoading(false);
    }
  }

  private async fetchUsers(groupId: string) {
    this.setIsLoading(true);
    try {
      const { data: users = [], headers } = await apiClient.fetchGroupUsersById(
        groupId,
        this.state.paging.current,
        this.userCountPerPage,
      );
      this.setState({
        users: users ?? [],
        paging: {
          ...this.state.paging,
          total: toTotalPage(
            Number(headers["pagination-count"]),
            this.userCountPerPage,
          ),
        },
      });
    } catch (e) {
      reportUnexpectedError(e);
      toast.error("ユーザー一覧の取得に失敗しました。");
    } finally {
      this.setIsLoading(false);
    }
  }

  private setIsLoading(isLoading: boolean) {
    this.setState({ isLoading });
  }
}
